import { useMemo } from 'react'
import { useIntl } from 'react-intl'

interface LocationSearchLabels {
  titleLabel: string
  titleLabelNaturalLanguage: string
  placeholderLabel: string
  placeholderLabelNaturalLanguage: string
  homesAndVillasPlaceholderLabel: string
}

/**
 * Returns localized labels for location search inputs
 * This hook should be used instead of the deprecated constants in constants/search.ts
 */
function useLocationSearchLabels(): LocationSearchLabels {
  const intl = useIntl()

  return useMemo(() => ({
    titleLabel: intl.formatMessage({
      id: 'Dsc8fhPw2_cmHFAj3Emh',
      defaultMessage: 'Where',
    }),
    titleLabelNaturalLanguage: intl.formatMessage({
      id: '6Uymqdk0HIUaVWDjWWRl',
      defaultMessage: 'Search hotels with AI',
    }),
    placeholderLabel: intl.formatMessage({
      id: 'e1RJ8agBjURemdfndzfK',
      defaultMessage: 'Search by destination or hotel',
    }),
    placeholderLabelNaturalLanguage: intl.formatMessage({
      id: 'j7HRtuff8XM2qnonZr1d',
      defaultMessage: 'Destination, hotel, or describe what you’re after',
    }),
    homesAndVillasPlaceholderLabel: intl.formatMessage({
      id: '7EylRX_d9iBlVOYag2ZU',
      defaultMessage: 'Search by destination or property',
    }),
  }), [intl])
}

export default useLocationSearchLabels
